import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import AuthService from "../services/auth.service";

export default function Dashboard() {
  const navigate = useNavigate();
  const user = AuthService.getCurrentUser();

  // loadingKey: "locationId-functionId" de la acción en curso
  const [loadingKey, setLoadingKey] = useState(null);

  if (!user) {
    navigate("/login");
    return null;
  }

  const buttons = user.buttons || [];

  const handleExecute = async (community, func) => {
    const key = `${community.locationId}-${func.functionId}`;
    setLoadingKey(key);

    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/execute`,
        {
          locationId: community.locationId,
          functionId: func.functionId,
          name: func.name,
        },
        { headers: { Authorization: `Bearer ${user.token}` } }
      );
      toast.success(`${func.name} ejecutado`);
    } catch (err) {
      const status = err.response?.status;
      if (status === 503) toast.error("Dispositivo sin conexión");
      else if (status === 403) toast.error("Sin permiso para esta acción");
      else toast.error(err.response?.data?.message || "Error al ejecutar");
    } finally {
      setLoadingKey(null);
    }
  };

  return (
    <div className="main-content">
      <div className="dashboard-header">
        <h1 className="dashboard-title">Panel de control</h1>
        <p className="dashboard-subtitle">
          {buttons.length} {buttons.length === 1 ? "comunidad" : "comunidades"} disponibles
        </p>
      </div>

      {buttons.length === 0 ? (
        <div className="empty-state">
          <div className="empty-state-icon">🏠</div>
          <p>No tienes acceso a ninguna comunidad todavía.</p>
        </div>
      ) : (
        buttons.map((community) => (
          <div key={community.locationId} className="location-card">
            <p className="location-title">{community.locationName}</p>
            <div className="action-grid">
              {community.functions.map((func) => {
                const key = `${community.locationId}-${func.functionId}`;
                const isLoading = loadingKey === key;
                return (
                  <button
                    key={func.functionId}
                    className={`btn-action${isLoading ? " loading" : ""}`}
                    onClick={() => handleExecute(community, func)}
                    disabled={loadingKey !== null}
                  >
                    {isLoading ? (
                      <><span className="spinner" />{func.action || func.name}</>
                    ) : (
                      func.action || func.name
                    )}
                  </button>
                );
              })}
            </div>
          </div>
        ))
      )}
    </div>
  );
}
